import * as constants from './constants';

export const initialState = {
  loading: false,
  error: undefined,
  carmenMakes: [],
  carmenUsers: [],
};

const vehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.GET_CARMEN_VEHICLE_FAIL:
    case constants.GET_CARMEN_VEHICLE_SUCCESS:
    case constants.UPDATE_CARMEN_VEHICLE_FAIL:
    case constants.UPDATE_CARMEN_VEHICLE_SUCCESS:
    case constants.GET_CARMEN_USERS_FAIL:
    case constants.GET_CARMEN_USERS_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default vehiclesReducer;
